const util = {
  // 判断是否对象
  isObject: (value) => value != null && typeof value === 'object',
  // 判断当前变量是否被定义（可用，不等于undefined或null）
  isDefined: (value) => value !== null && typeof value !== 'undefined',
  // 复制两个对象上面具有相同的属性
  copySameProperty(target, source) {
    let copy;
    const _tmp = {};
    Object.keys(target).map((val) => {
      if (val in source) {
        copy = source[val];
        _tmp[val] = copy;
      }
    });
    return _tmp;
  },
  // 深拷贝，太粗暴，待改善，！！
  deepCopy(obj) {
    if (util.isDefined(obj)) {
      return JSON.parse(JSON.stringify(obj));
    }
    return {};
  },
  /**
   * 转成int类型
   * @param  {any} val 被转的输入值
   * @param  {any} defaultValue 强转失败后的默认值
   * @return {int}     如果强转失败，则返回默认值
   */
  parseInt(val, defaultValue = 0) {
    val = parseInt(val, 10);
    return isNaN(val) ? defaultValue : val;
  },
  // 获取当前时间戳
  getTimestamp() {
    return new Date().getTime();
  },
};

export default util;



// WEBPACK FOOTER //
// ./src/common/util.js